import FilterCheckboxChip from './FilterCheckboxChip';
import HealthStatTooltip from '../HealthStatTooltip';
import { PricePointMetricIcon } from '../HealthStats';
import Stack from '../Stack';
import { handleMixpanelEvent } from '../FilterAccordion/FilterAccordionItem';
import { healthStatFilterOptions } from 'utils/filters';
import styled from 'styled-components';
import { withMixpanelChange } from 'utils/app';

const pricePointFilter = healthStatFilterOptions.find(
    ({ label }) => label === 'price point',
);

const Wrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space_6}px;
`;

const PricePointFilterChipsUntracked = ({
    children,
    filters,
    setFilter,
    onChange,
    ...props
}) => {
    const appliedFilters = filters.healthStats
        ? filters.healthStats
              .filter(({ value }) =>
                  pricePointFilter.options.some(
                      ({ value: optionValue }) => value === optionValue,
                  ),
              )
              .map(({ value }) => value)
        : null;

    return (
        <Wrapper {...props}>
            {children}
            {pricePointFilter.options
                .slice()
                .reverse()
                .map((option) => {
                    const { label, value, score, metricLabel } = option;
                    const checked =
                        !!appliedFilters && appliedFilters.includes(value);

                    return (
                        <HealthStatTooltip
                            metricLabel={metricLabel}
                            label={label}
                            score={score}
                            key={label}
                        >
                            <FilterCheckboxChip
                                checked={checked}
                                onChange={() =>
                                    onChange({
                                        action: checked
                                            ? 'remove-value'
                                            : 'select-option',
                                        option,
                                    })
                                }
                                preserveIconSpace={false}
                            >
                                <Stack
                                    $direction="row"
                                    as="span"
                                    $space="1ch"
                                    css="display: inline-flex;"
                                >
                                    <span
                                        css={`
                                            color: ${({ theme }) =>
                                                theme.purple_1};
                                            display: inline-flex;
                                        `}
                                    >
                                        <PricePointMetricIcon score={score} />
                                    </span>
                                    <span>{label}</span>
                                </Stack>
                            </FilterCheckboxChip>
                        </HealthStatTooltip>
                    );
                })}
        </Wrapper>
    );
};

const PricePointFilterChipsWithMixpanel = withMixpanelChange(
    PricePointFilterChipsUntracked,
    'PricePointFilterChips',
);

export const PricePointFilterChips = ({
    handleMixpanelEvent: handleMixpanelEventProp = handleMixpanelEvent,
    mixpanelContext = 'PricePointFilterSelect',
    ...props
}) => {
    return (
        <PricePointFilterChipsWithMixpanel
            handleMixpanelEvent={handleMixpanelEventProp}
            mixpanelContext={mixpanelContext}
            {...props}
        />
    );
};

export default PricePointFilterChips;
